(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /*
    Darling Lux: <slideshow-component> re-enables itself on connect
    (connectedCallback sets disabled = isNested), which brings back mouse drag
    between card images — a click with a tiny mouse movement then changed the
    picture instead of opening the product. Keep card galleries disabled.
    Variant swatches still switch the image: select() ignores this attribute.
  */
  (function () {
    if (window.__dlxStaticCardGallery) return;
    window.__dlxStaticCardGallery = true;
    var SEL = '.card-gallery[data-dlx-static] slideshow-component';
    function lock(el) {
      if (el.getAttribute('disabled') !== 'true') el.setAttribute('disabled', 'true');
    }
    function lockAll(root) {
      (root || document).querySelectorAll(SEL).forEach(lock);
    }
    customElements.whenDefined('slideshow-component').then(function () { lockAll(); });
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          if (r.target.matches && r.target.matches(SEL)) lock(r.target);
        } else {
          r.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches(SEL)) lock(n);
            lockAll(n);
          });
        }
      }
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
